module.exports = "/_next/static/images/mohit-5aa4475b8f6885fb440f20309e83b1a8.png";